import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { AccessTokensViewProvider } from 'pages/settings/pages/developer/pages/accessTokens/context/accessTokensViewContext'

const AccessTokensPageLayoutContent = () => {
  return <Outlet />
}

export const AccessTokensPageLayout = observer(() => {
  return (
    <AccessTokensViewProvider>
      <AccessTokensPageLayoutContent />
    </AccessTokensViewProvider>
  )
})
